import { ReactNode, useMemo } from "react";
import { Badge, BadgeProps } from "./badge";
import { cn } from "@/lib/utils";

export interface NotificationBadgeProps {
  children: ReactNode;
  notifNumber: number;
  badgeProps?: BadgeProps;
  className?: string;
}

export const NotificationBadge = ({
  children,
  notifNumber,
  badgeProps,
  className,
}: NotificationBadgeProps) => {
  const safeNotifNumber = useMemo(
    () =>
      notifNumber != null ? (notifNumber > 9 ? "9+" : notifNumber) : undefined,
    [notifNumber],
  );

  return (
    <div className="relative inline-block">
      {children}
      <Badge
        className={cn("absolute text-xs text-center align-middle p-0 w-5 h-5 rounded-[50%] inline top-[-10px] right-[-10px]", className)}
        {...badgeProps}
      >
        {safeNotifNumber}
      </Badge>
    </div>
  );
};